import React from 'react';

const Pulse = ({ className }) => (
  <div className={`animate-pulse rounded-lg bg-gray-200 ${className}`} />
);

export const BlogCardSkeletonCompact = () => (
  <div className="flex gap-3 py-3">
    <div className="h-16 w-20 shrink-0 animate-pulse rounded-lg bg-gray-200" />
    <div className="flex flex-1 flex-col gap-2 py-1">
      <Pulse className="h-3.5 w-full" />
      <Pulse className="h-3.5 w-4/5" />
      <div className="flex gap-2 mt-1">
        <Pulse className="h-3 w-10" />
        <Pulse className="h-3 w-10" />
        <Pulse className="h-3 w-10" />
      </div>
    </div>
  </div>
);

const BlogCardSkeleton = () => (
  <div className="overflow-hidden rounded-[26px] border border-gray-100 bg-white shadow-sm">
    {/* Image */}
    <div className="h-40 w-full animate-pulse bg-gray-200" />
    {/* Body */}
    <div className="px-4 pb-4 pt-3.5 space-y-3">
      {/* Title */}
      <Pulse className="h-4 w-full" />
      <Pulse className="h-4 w-3/4" />
      {/* Excerpt */}
      <Pulse className="h-3.5 w-full" />
      <Pulse className="h-3.5 w-5/6" />
      {/* Stats */}
      <div className="flex gap-2 pt-1">
        <Pulse className="h-6 w-14 rounded-full" />
        <Pulse className="h-6 w-14 rounded-full" />
        <Pulse className="h-6 w-14 rounded-full" />
      </div>
      {/* Author row */}
      <div className="flex items-center justify-between border-t border-gray-100 pt-3">
        <div className="flex items-center gap-2.5">
          <Pulse className="h-9 w-9 rounded-full" />
          <div className="space-y-1.5">
            <Pulse className="h-3 w-24" />
            <Pulse className="h-2.5 w-16" />
          </div>
        </div>
        <Pulse className="h-3.5 w-16" />
      </div>
    </div>
  </div>
);

export default BlogCardSkeleton;
